import React from 'react';

const FilterButton = ({ label, active, onClick, color, darkMode }) => {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-2 rounded-full text-sm mr-2 mb-1 ${active
        ? (darkMode ? 'bg-blue-700 text-white' : 'bg-blue-500 text-white')
        : (darkMode ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-800')
        } ${color ? 'flex items-center' : ''}`}
      aria-pressed={active}
    >
      {color && (
        <div
          className="w-3 h-3 rounded-full mr-2"
          style={{
            backgroundColor:
              color === "Чёрный" ? "#000" :
                color === "Серебристый" ? "#C0C0C0" :
                  color === "Черно-серый" ? "linear-gradient(to right, #000 50%, #C0C0C0 50%)" : "#888"
          }}
          aria-hidden="true"
        ></div>
      )}
      {label}
    </button>
  );
};

export default FilterButton;